import { serializeAEMCookieCollection, setCookie } from 'utils/cookie';
import { SHOPPING_LIST_COOKIE_KEY } from 'common/constants';

export const serializeShoppinglist = serializeAEMCookieCollection((item: string) => `${item}:1`);

export function dispatchWishlistEvent(domain: string, list: string[]) {
  setCookie(SHOPPING_LIST_COOKIE_KEY, serializeShoppinglist(list), {
    path: '/',
    domain: `.${domain}`,
    expires: new Date(new Date().getFullYear() + 1, 12, 31),
  });

  document.body.dispatchEvent(
    new CustomEvent('wishlist:update', {
      cancelable: true,
      bubbles: true,
      composed: true,
    }),
  );
}
